import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { NumberFormatterService } from '../../../../core/services/number.formatter.service';

@Component({
  selector: 'app-amenities-dialog',
  templateUrl: './amenities-dialog.component.html',
  styleUrls: ['./amenities-dialog.component.scss'],
})
export class AmenitiesDialogComponent implements OnInit {
  vessel: Vessel;
  amenities: string[];

  constructor(
    public dialogRef: MatDialogRef<AmenitiesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private numFormatter: NumberFormatterService,
  ) {
    this.vessel = data.vessel;

    this.amenities = this.numFormatter.parseArrayFromJson(this.vessel.features);
  }

  ngOnInit(): void {}
}
